import { createPluginFactory } from '@udecode/plate';
import { Editor } from 'slate';
import { GenerateContentElement } from './nodes/GenerateContentElement';
import { GenerateContentElementUI } from './ui/GenerateContentElementUI';
import { withGeneratedContent } from './withGeneratedContent';
import { unwrapGeneratedContent } from './commands/unwrapGeneratedContent';

export const checkSelection = (editor) => () => {
  editor.highlighted = editor.selection
    ? Editor.string(editor, editor.selection)
    : null;
};

export const processGeneratedContent = (editor) => () => {
  unwrapGeneratedContent({ editor });
};

export const createGenerateContentPlugin = createPluginFactory({
  key: GenerateContentElement.type,
  isElement: true,
  component: GenerateContentElementUI,
  withOverrides: withGeneratedContent,
  handlers: {
    onKeyDown: processGeneratedContent,
    onMouseUp: processGeneratedContent,
    onChange: checkSelection,
    onFocus: checkSelection,
  },
});
